import { render, staticRenderFns } from "./bind-env.vue?vue&type=template&id=5b1aea5a&scoped=true&"
import script from "./bind-env.vue?vue&type=script&lang=js&"
export * from "./bind-env.vue?vue&type=script&lang=js&"
import style0 from "./bind-env.vue?vue&type=style&index=0&id=5b1aea5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1aea5a",
  null
  
)

export default component.exports